import * as formatHelper from "../../helpers/formatHelper";

import Dialog from "./Dialog";

/**
 * @class ProgressDialog
 */
export default class ProgressDialog extends Dialog {
    /**
     * @param   {Number}    id
     * @param   {String}    type
     * @param   {String}    text
     * @param   {Number}    message
     * @param   {String}    messageCode
     * @param   {Number}    icon
     * @param   {Array}     buttons
     * @param   {Array}     params
     * @param   {Object}    meta
     * @param   {String}    progressType
     * @param   {Array}     progressItems
     */
    constructor(id, type, text, message, messageCode, icon, buttons, params, meta, progressType, progressItems) {
        super(id, type, text, message, messageCode, icon, buttons, params, meta);

        this._progressType = progressType;
        this._progressItems = progressItems;
        this._percentage = 0;
        this._timeLeft = 0;
        this._progressItemsCount = 0;
        this._progressItemsDone = 0;
    }

    /**
     * @param {String} progressType
     */
    set progressType(progressType) {
        this._progressType = progressType;
    }

    /**
     * @return {String}
     */
    get progressType() {
        return this._progressType;
    }

    /**
     * @param {Array} progressItems
     */
    set progressItems(progressItems) {
        this._progressItems = progressItems;
    }

    /**
     * @return {Array}
     */
    get progressItems() {
        return this._progressItems;
    }

    /**
     * @return {Number}
     */
    get percentage() {
        return this._percentage;
    }

    /**
     * @param {Number} percentage
     */
    set percentage(percentage) {
        this._percentage = percentage;
    }

    /**
     * @return {Number}
     */
    get timeLeft() {
        return this._timeLeft;
    }

    /**
     * @param {Number} timeLeft
     */
    set timeLeft(timeLeft) {
        this._timeLeft = timeLeft;
    }

    /**
     * @return {Number}
     */
    get progressItemsCount() {
        return this._progressItemsCount;
    }

    /**
     * @param {Number} progressItemsCount
     */
    set progressItemsCount(progressItemsCount) {
        this._progressItemsCount = progressItemsCount;
    }

    /**
     * @return {Number}
     */
    get progressItemsDone() {
        return this._progressItemsDone;
    }

    /**
     * @param {Number} progressItemsDone
     */
    set progressItemsDone(progressItemsDone) {
        this._progressItemsDone = progressItemsDone;
    }

    /**
     * Clones dialog object.
     *
     * @return  {Object}
     */
    clone = () => {
        let dialog = new ProgressDialog(
            this._id,
            this._type,
            this._text,
            this._message,
            this._messageCode,
            this._icon,
            this._buttons,
            this._params,
            this._meta,
            this._progressType,
            this._progressItems
        );
        dialog.progressItemsCount = this._progressItemsCount;
        dialog.progressItemsDone = this._progressItemsDone;

        return dialog;
    };

    /**
     * Clones dialog object and updates progressItems property.
     *
     * @param   {Number | null} percentage
     * @param   {Number | null} timeLeft
     * @param   {Array}         progressItems
     * @return  {Object}
     */
    updateProgressItems = (percentage, timeLeft, progressItems, progressItemsCount, progressItemsDone) => {
        let dialog = this.clone();
        dialog.percentage = percentage === null ? 0 : percentage * 100;
        dialog.timeLeft = timeLeft === null ? 0 : formatHelper.formatDecimal(timeLeft);
        dialog.progressItems = progressItems;
        dialog.progressItemsCount = progressItemsCount;
        dialog.progressItemsDone = progressItemsDone;

        return dialog;
    };
}
